import { useQuery } from "react-query";
import { sureApiCall } from "src/api/axiosClient/sureApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { ActionsSchema, ActionsType, SureCsrTheme } from "./useGetOneAction";

export const getAllActionsKey = "getAllActions" as const;

export type Options = {
    ssqId: number;
};
export const useGetAllActions = (options: Options) => {
    const { ssqId } = options;

    const query = useQuery({
        queryKey: [getAllActionsKey],
        cacheTime: 5,
        queryFn: async () => {
            const url = `/api/actions`;
            return await sureApiCall.get(url, {
                params: {
                    itemsPerPage: 20000,
                    ssqId: ssqId,
                },
            });
        },
        select: (response) => {
            const actions = response.data["hydra:member"];
            const data = zodParseWithLog(actions, ActionsSchema.array(), getAllActionsKey);
            return data;
        },
    });

    const actions = query.data;

    const getActionsByCsrTheme = (): ActionsByCsrThemes => {
        if (actions === undefined) return {};

        const flattenActionsByCsrThemes = actions.flatMap((action) => {
            const newActionList = action.csrThemes.reduce<FlattenedActionsCsrThemes[]>((acc, csrTheme) => {
                acc.push({
                    ...action,
                    csrTheme,
                });
                return acc;
            }, []);
            return newActionList;
        });

        const groupedActions = Object.groupBy(flattenActionsByCsrThemes, (action) => action.csrTheme.title);

        return groupedActions;
    };

    return {
        actions,
        getActionsByCsrTheme,
        ...query,
    };
};

type FlattenedActionsCsrThemes = Omit<ActionsType, "csrThemes"> & {
    csrTheme: SureCsrTheme;
};
export type ActionsByCsrThemes = Partial<Record<string, FlattenedActionsCsrThemes[]>>;
